import constantes from './constantes';

export const isExternalApresentation = () => {
    return sessionStorage.getItem(`${constantes.localStoragePrefix}-externo`) === 'true';
};

export const setExternalApresentation = () => sessionStorage.setItem(`${constantes.localStoragePrefix}-externo`, 'true');

export const removeExternalApresentation = () => sessionStorage.removeItem(`${constantes.localStoragePrefix}-externo`);
